import { useMemo } from 'react'

// Define due amount types in order (future first)
let DUE_AMOUNT_TYPES = [
  'due_30_days',
  'due_60_days',
  'due_90_days',
  'due_now',
  'future_due',
  'total_due',
]

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    // Extract treatment
    let treatment = data.vaxiom_txs?.[0]

    // Create categories - group payment accounts by due amount type
    let categories = DUE_AMOUNT_TYPES.map(type => {
      // Aggregate by unique payment account (payment_account_id + insured_id)
      let accountsMap = new Map()

      data.payments_patient_payment_account_due_amounts.forEach(account => {
        // Create unique key: payment_account_id + insured_id (for insurance)
        let key = `${account.payment_account_id}--${account.insured_id ?? 'null'}`

        if (accountsMap.has(key)) {
          // Sum the amount if account already exists
          let existing = accountsMap.get(key)
          existing.amount += account[type]
        } else {
          // Add new account entry
          accountsMap.set(key, {
            ...account,
            amount: account[type],
          })
        }
      })

      // Convert map back to array
      let payment_accounts = Array.from(accountsMap.values())

      let total = payment_accounts.reduce(
        (sum, account) => sum + account.amount,
        0
      )

      return {
        type,
        payment_accounts,
        total,
      }
    })

    return {
      treatment,
      categories,
    }
  }, [data])
}
